<template>
  <div style="width: 100%">
    <v-layout row>
      <v-flex 6 xs12 sm offset-sm3>
        <v-card>
          <v-list two-line>
            <template v-for="(item, index) in chat_list">
              <v-subheader v-if="item.header" :key="index">{{ item.header }}</v-subheader>

              <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

              <v-list-tile v-else :key="index" avatar ripple @click="goChatDetail(item)">
                <v-list-tile-avatar>
                  <i class="material-icons" style="font-size:35px">{{item.avatar}}</i>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="item.title"
                    style="white-space:normal; height:fit-content;"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "user-chat",
  data() {
    return {};
  },
  methods: {
    goChatDetail(chat) {
      this.$router.push({
        name: "admin-chat-detail",
        params: { chat: chat.data }
      });
    }
  },
  computed: {
    chat_list() {
      let chat_list = [];
      let chats = this.$store.getters.getAdminChats;

      chats.forEach((chat, idx) => {
        chat_list.push({
          header: "Created: " + moment(chat.createdAt).format("MMMM Do YYYY")
        });
        chat_list.push({
          avatar: "account_circle",
          title: chat.title || "* No Title Entered *",
          subtitle: "Chat Owner: " + chat.user_id,
          data: chat
        });
      });
      return chat_list;
    }
  }
};
</script>

<style scoped>
</style>


